import React from "react";
import { ColorBoxLabel } from "../../../components/ColorBox";
import { Stats } from "../../../state/types";
import { FoldKV, KV, SubKV } from "../util";
import { Legend, legendElem } from "./legend";

interface ScoreProps {
  stats: Stats;
  label: string;
  prop: string;
  // Als ingesprongen subregel onder een FoldKV
  sub?: boolean;
  legend: Legend;
  children?: React.ReactNode;
}
export const Score = ({ stats, label, prop, legend, sub, children }: ScoreProps) => {
  const value = stats?.[prop];
  if (value === undefined) return null;
  const Row = sub ? SubKV : KV;
  return (
    <Row k={label}>
      <ColorBoxLabel elem={legendElem(value, legend)}>{children}</ColorBoxLabel>
    </Row>
  );
};

export const StatScores = ({
  stats,
  mapping,
  title,
  legend,
  subLegend = legend,
  info,
}: {
  stats: Record<string, number>;
  mapping: Record<string, string>;
  title: string;
  legend: Legend;
  // De subregels in hun eigen klassen (Leefbaarometer: bijdrage per dimensie)
  subLegend?: Legend;
  // Naast de klasse in de kopregel, bijv. een ITooltip met de bron
  info?: React.ReactNode;
}) => {
  const score = stats?.score;
  if (score === undefined) return null;
  return (
    <FoldKV
      k={title}
      summary={<ColorBoxLabel elem={legendElem(score, legend)}>{info}</ColorBoxLabel>}
    >
      {Object.entries(mapping).map(([prop, label]) => (
        <Score sub key={prop} stats={stats} label={label} prop={prop} legend={subLegend} />
      ))}
    </FoldKV>
  );
};
